import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * 密码重置邮件已发送提示页面
 * 与登录/注册页面保持一致的简洁风格
 *
 * 显示内容：
 * - 成功图标和提示
 * - 后续操作指引
 * - 返回登录按钮
 * - 多语言支持
 */
export default function PasswordEmailSent() {
  const { t } = useTranslation("login");

  return (
    <div className="min-h-[calc(100vh-4rem)] flex flex-col items-center justify-center px-4 py-8 sm:py-12">
      <div className="w-[300px] flex flex-col">
        {/* 成功图标和标题 */}
        <div className="text-center mb-8">
          <div className="mx-auto w-16 h-16 bg-green-100 dark:bg-green-900/50 rounded-full flex items-center justify-center mb-4">
            <CheckCircle2 className="w-10 h-10 text-green-600 dark:text-green-400" />
          </div>
          <h1 className="text-2xl font-semibold tracking-tight text-foreground mb-2">
            {t("emailSent.title")}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t("emailSent.subtitle")}
          </p>
        </div>

        {/* 提示信息 */}
        <div className="space-y-3 mb-6">
          <p className="text-sm text-muted-foreground text-center">
            {t("emailSent.step1Desc")}
          </p>
          <p className="text-xs text-muted-foreground/70 text-center">
            请{t("emailSent.notReceivedTip1")}
          </p>
        </div>

        {/* 操作按钮 */}
        <div className="space-y-3">
          <Button className="w-full" asChild>
            <Link to="/login">{t("emailSent.backToLogin")}</Link>
          </Button>

          <Button variant="outline" className="w-full" asChild>
            <Link to="/forgot-password">{t("emailSent.resendEmail")}</Link>
          </Button>
        </div>
      </div>

      {/* 底部条款 */}
      <footer className="fixed bottom-0 left-0 right-0 py-6 px-4 text-center text-xs text-muted-foreground">
        <p>
          {t("app.loginAgreement", "继续即表示您同意我们的")}{" "}
          <Link to="/terms" className="hover:text-foreground transition-colors">
            {t("app.terms", "服务条款")}
          </Link>
          {t("app.agreementMiddle", " 和 ")}{" "}
          <Link
            to="/privacy"
            className="hover:text-foreground transition-colors"
          >
            {t("app.privacy", "隐私政策")}
          </Link>
        </p>
      </footer>
    </div>
  );
}
